export default {
    NCFJobsReports: [],
    NCFJobsReportsLoading: false,
    reportsSummariesFilters: setInitialNCFJobsReportsFilters(),
}
function setInitialNCFJobsReportsFilters() {
    return {
        createdAt__lte: null,
        createdAt__gte: null,
    }
}